module.exports = __webpack_public_path__ + "img/ico_checkbox-white.9b9b0670.svg";